import { t } from 'i18next';
import ModalDialog from '../../../common/modal-dialog/modal-dialog.component';
import { HeaderSecondary } from '../../../common/typography/typography.styles';
import { ModalTextBody } from '../../../common/modal-dialog/modal-dialog.styles';
import { ReactComponent as ExclamationCircle } from '../../../assets/exclamation-circle.svg';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onApprove: () => void;
  cancelBtnText?: string;
  title?: string;
  text?: string;
}

const DeleteItemDialog = ({
  isOpen = false,
  cancelBtnText = 'cancel',
  title = 'delete_item',
  text = 'the_action_cannot_be_canceled',
  onClose,
  onApprove,
}: Props) => (
  <ModalDialog
    isDanger
    approveBtnContent={t('delete')}
    cancelBtnContent={t(cancelBtnText)}
    isOpen={isOpen}
    onApprove={onApprove}
    onClose={onClose}>
    <div className='delete-dialog-title'>
      <ExclamationCircle />
      <HeaderSecondary>{t(title)}</HeaderSecondary>
    </div>
    <ModalTextBody>{t(text)}</ModalTextBody>
  </ModalDialog>
);

export default DeleteItemDialog;
